const pageNameKey = "otaAcceptAndCreateBackupProcessModal";

export const otaAcceptAndCreateBackupProcessModalEn = {
  [pageNameKey]: {
    closeModalAriaLabel: "Close accept and create backup process modal",
    title: "Accept and Create Backup",
    targetPathLabel: "Path to back up (subfolders and files included)",
    sourceMachineLabel: "Source machine",
    backupPathContainsSectionTitle:
      "Backup path {target_path} contains the following folders and files:",
    warningText: "Do you want to create a backup of these folders and files?",
    cancelButtonText: "Cancel",
    acceptAndCreateBackupButtonText: "Accept and Create Backup",
    startSuccessMessage: "Backup process started successfully.",
    startFailureMessage: "Failed to start backup process",
    startErrorMessage: "Error starting backup process",
    waitMessage:
      "Wait until the availability check of the machine is finished.",
  },
};

export const otaAcceptAndCreateBackupProcessModalPtBr = {
  [pageNameKey]: {
    closeModalAriaLabel: "Fechar modal de aceitar e criar processo de backup",
    title: "Aceitar e criar backup",
    targetPathLabel: "Caminho para backup (subpastas e arquivos incluídos)",
    sourceMachineLabel: "Máquina de origem",
    backupPathContainsSectionTitle:
      "O caminho de backup {target_path} contém as seguintes pastas e arquivos:",
    warningText: "Deseja criar um backup dessas pastas e arquivos?",
    cancelButtonText: "Cancelar",
    acceptAndCreateBackupButtonText: "Aceitar e criar backup",
    startSuccessMessage: "Processo de backup iniciado com sucesso.",
    startFailureMessage: "Falha ao iniciar o processo de backup",
    startErrorMessage: "Erro ao iniciar o processo de backup",
    waitMessage:
      "Aguarde ate que a verificacao de disponibilidade da maquina seja concluida.",
  },
};

export const otaAcceptAndCreateBackupProcessModalDe = {
  [pageNameKey]: {
    closeModalAriaLabel:
      "Modal zum Akzeptieren und Erstellen des Backup-Prozesses schließen",
    title: "Akzeptieren und Backup erstellen",
    targetPathLabel:
      "Pfad für das Backup (Unterordner und Dateien eingeschlossen)",
    sourceMachineLabel: "Quellmaschine",
    backupPathContainsSectionTitle:
      "Der Backup-Pfad {target_path} enthält folgende Ordner und Dateien:",
    warningText: "Möchten Sie ein Backup dieser Ordner und Dateien erstellen?",
    cancelButtonText: "Abbrechen",
    acceptAndCreateBackupButtonText: "Akzeptieren und Backup erstellen",
    startSuccessMessage: "Backup-Prozess erfolgreich gestartet.",
    startFailureMessage: "Backup-Prozess konnte nicht gestartet werden",
    startErrorMessage: "Fehler beim Starten des Backup-Prozesses",
    waitMessage:
      "Warten Sie, bis die Verfuegbarkeitspruefung der Maschine abgeschlossen ist.",
  },
};

export const otaAcceptAndCreateBackupProcessModalZhHans = {
  [pageNameKey]: {
    closeModalAriaLabel: "关闭接受并创建备份流程弹窗",
    title: "接受并创建备份",
    targetPathLabel: "备份路径（包含子文件夹和文件）",
    sourceMachineLabel: "源设备",
    backupPathContainsSectionTitle:
      "备份路径 {target_path} 包含以下文件夹和文件：",
    warningText: "您要为这些文件夹和文件创建备份吗？",
    cancelButtonText: "取消",
    acceptAndCreateBackupButtonText: "接受并创建备份",
    startSuccessMessage: "备份流程已成功启动。",
    startFailureMessage: "启动备份流程失败",
    startErrorMessage: "启动备份流程时出错",
    waitMessage: "请等待，直到设备可用性检查完成。",
  },
};

export const otaAcceptAndCreateBackupProcessModalIt = {
  [pageNameKey]: {
    closeModalAriaLabel:
      "Chiudi la finestra di accettazione e creazione del processo di backup",
    title: "Accetta e crea backup",
    targetPathLabel: "Percorso di backup (sottocartelle e file inclusi)",
    sourceMachineLabel: "Macchina sorgente",
    backupPathContainsSectionTitle:
      "Il percorso di backup {target_path} contiene le seguenti cartelle e file:",
    warningText: "Vuoi creare un backup di queste cartelle e file?",
    cancelButtonText: "Annulla",
    acceptAndCreateBackupButtonText: "Accetta e crea backup",
    startSuccessMessage: "Processo di backup avviato con successo.",
    startFailureMessage: "Impossibile avviare il processo di backup",
    startErrorMessage: "Errore durante l'avvio del processo di backup",
    waitMessage:
      "Attendere fino al completamento del controllo di disponibilità della macchina.",
  },
};

export const otaAcceptAndCreateBackupProcessModalEs = {
  [pageNameKey]: {
    closeModalAriaLabel: "Cerrar modal de aceptar y crear proceso de respaldo",
    title: "Aceptar y crear respaldo",
    targetPathLabel: "Ruta para respaldo (subcarpetas y archivos incluidos)",
    sourceMachineLabel: "Máquina de origen",
    backupPathContainsSectionTitle:
      "La ruta de respaldo {target_path} contiene las siguientes carpetas y archivos:",
    warningText: "¿Desea crear un respaldo de estas carpetas y archivos?",
    cancelButtonText: "Cancelar",
    acceptAndCreateBackupButtonText: "Aceptar y crear respaldo",
    startSuccessMessage: "Proceso de respaldo iniciado correctamente.",
    startFailureMessage: "No se pudo iniciar el proceso de respaldo",
    startErrorMessage: "Error al iniciar el proceso de respaldo",
    waitMessage:
      "Espere hasta que se complete la verificacion de disponibilidad de la maquina.",
  },
};

export const otaAcceptAndCreateBackupProcessModalNl = {
  [pageNameKey]: {
    closeModalAriaLabel:
      "Venster voor accepteren en maken van back-upproces sluiten",
    title: "Accepteren en back-up maken",
    targetPathLabel: "Pad voor back-up (submappen en bestanden inbegrepen)",
    sourceMachineLabel: "Bronmachine",
    backupPathContainsSectionTitle:
      "Back-uppad {target_path} bevat de volgende mappen en bestanden:",
    warningText: "Wilt u een back-up maken van deze mappen en bestanden?",
    cancelButtonText: "Annuleren",
    acceptAndCreateBackupButtonText: "Accepteren en back-up maken",
    startSuccessMessage: "Back-upproces succesvol gestart.",
    startFailureMessage: "Back-upproces kon niet worden gestart",
    startErrorMessage: "Fout bij het starten van het back-upproces",
    waitMessage:
      "Wacht tot de beschikbaarheidscontrole van de machine is voltooid.",
  },
};

export const otaAcceptAndCreateBackupProcessModalTr = {
  [pageNameKey]: {
    closeModalAriaLabel: "Yedeği kabul et ve oluştur penceresini kapat",
    title: "Kabul Et ve Yedekleme Oluştur",
    targetPathLabel: "Yedeklenecek yol (alt klasörler ve dosyalar dahil)",
    sourceMachineLabel: "Kaynak makinesi",
    backupPathContainsSectionTitle:
      "{target_path} yedekleme yolu aşağıdaki klasörleri ve dosyaları içerir:",
    warningText: "Bu klasör ve dosyaların yedeğini oluşturmak istiyor musunuz?",
    cancelButtonText: "İptal etmek",
    acceptAndCreateBackupButtonText: "Kabul Et ve Yedekleme Oluştur",
    startSuccessMessage: "Yedekleme işlemi başarıyla başlatıldı.",
    startFailureMessage: "Yedekleme işlemi başlatılamadı",
    startErrorMessage: "Yedekleme işlemi başlatılırken hata oluştu",
    waitMessage: "Makinenin kullanılabilirlik kontrolü bitene kadar bekleyin.",
  },
};
